import React from "react";
import { Tag, Tooltip } from "antd";

// isMatch: the code equals one on the source description (matching screen); shown in green
export const TaxonomyItemCodeBox = React.memo<{ type: string; code: string; isMatch?: boolean }>(({
  type,
  code,
  isMatch,
}) => {
  if (!code || !type) return null;

  return (
    <Tooltip title={type}>
      <Tag
        color={isMatch ? "success" : undefined}
        style={{ margin: 0 }}
        className="max-w-full whitespace-normal cursor-help"
      >
        {code}
      </Tag>
    </Tooltip>
  );
});
